import script from "./buybox-purchase-info.vue?vue&type=script&setup=true&lang=js"
export * from "./buybox-purchase-info.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__